import accordion from './components/accordion';

document.addEventListener(
  'DOMContentLoaded',
  () => {
    accordion()
  },
  false
)
